import React from 'react';

const DisclaimerPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6">Legal Disclaimer</h1>
      
      <div className="bg-gray-50 p-6 rounded-lg shadow-sm mb-8">
        <p className="text-red-600 font-semibold mb-4">IMPORTANT: PLEASE READ THIS DISCLAIMER CAREFULLY</p>
        <p className="mb-4">
          This disclaimer governs your use of our website and services. By using our services, 
          you accept this disclaimer in full. If you disagree with any part of this disclaimer, 
          you must not use our website and services.
        </p>
      </div>

      <h2 className="text-2xl font-semibold mb-4">Not Professional Advice</h2>
      <p className="mb-6">
        The content provided through Explanatum's services, including but not limited to business ideas, 
        business plans, market analyses, financial projections, and any other materials generated by our application 
        ("Content"), is for informational purposes only. The Content is not intended to constitute professional 
        advice, whether legal, financial, business, or otherwise, and should not be relied upon as such.
      </p>

      <h2 className="text-2xl font-semibold mb-4">No Substitute for Professional Consultation</h2>
      <p className="mb-6">
        Our Content is designed to give users a starting point for developing their business ideas. However:
      </p>
      <ul className="list-disc pl-8 mb-6">
        <li className="mb-2">
          We strongly recommend that users consult with qualified professionals, including but not limited to business advisors, 
          lawyers, accountants, financial advisors, and other experts before making any business decisions or taking any actions 
          based on our Content.
        </li>
        <li className="mb-2">
          Laws, regulations, market conditions, and best practices vary by jurisdiction, industry, and over time. What may be 
          appropriate in one context may be inappropriate or even unlawful in another.
        </li>
        <li className="mb-2">
          Users are solely responsible for ensuring that any actions they take comply with all applicable laws, regulations, 
          and requirements in their jurisdiction.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">Jurisdiction-Specific Disclaimers</h2>
      
      <h3 className="text-xl font-semibold mb-3">United Kingdom</h3>
      <p className="mb-4">
        In accordance with UK law, including the Consumer Rights Act 2015, the Financial Services and Markets Act 2000, 
        and other applicable legislation, we explicitly disclaim any liability for business decisions made in reliance on our Content. 
        Our services do not constitute regulated financial advice, legal advice, tax advice, or investment advice as defined under UK law.
      </p>
      
      <h3 className="text-xl font-semibold mb-3">European Union</h3>
      <p className="mb-4">
        In accordance with EU laws and regulations, including but not limited to the E-Commerce Directive (2000/31/EC), 
        the Consumer Rights Directive (2011/83/EU), and the General Data Protection Regulation (GDPR), we clarify that our 
        services are not a substitute for professional advice. Our Content should not be construed as professional advice 
        regulated under the laws of any EU member state.
      </p>
      
      <h3 className="text-xl font-semibold mb-3">United States</h3>
      <p className="mb-6">
        In accordance with US laws and regulations at both federal and state levels, we clarify that our services do not 
        constitute legal, financial, investment, or business advice as defined under applicable US laws. We are not licensed 
        attorneys, financial advisors, investment advisors, or other regulated professionals in any US jurisdiction. Our Content 
        is not tailored to meet the specific requirements of any federal, state, or local laws or regulations.
      </p>

      <h2 className="text-2xl font-semibold mb-4">No Warranty</h2>
      <p className="mb-6">
        The Content is provided "as is," without any warranties or guarantees, express or implied. We do not warrant or represent that:
      </p>
      <ul className="list-disc pl-8 mb-6">
        <li className="mb-2">The Content is accurate, complete, or up-to-date;</li>
        <li className="mb-2">The Content is suitable for any particular purpose or business context;</li>
        <li className="mb-2">Implementation of ideas or plans generated will result in any particular outcome, including profit or success;</li>
        <li className="mb-2">The Content complies with applicable laws or regulations in any jurisdiction.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">Limitation of Liability</h2>
      <p className="mb-6">
        To the maximum extent permitted by applicable law, we exclude all liability and responsibility for any loss, damage, 
        or expense (including any direct, indirect, or consequential loss, financial or otherwise) that may arise, directly or indirectly, 
        from your use of, or reliance on, our Content or services.
      </p>

      <h2 className="text-2xl font-semibold mb-4">User Responsibility</h2>
      <p className="mb-6">
        By using our services, you acknowledge and agree that you will exercise your own independent judgment and due diligence 
        in evaluating and implementing any business ideas, plans, or other Content generated through our services. You assume 
        full responsibility for all decisions made and actions taken based on our Content.
      </p>

      <h2 className="text-2xl font-semibold mb-4">Modifications to this Disclaimer</h2>
      <p className="mb-6">
        We may update this disclaimer from time to time by posting a new version on our website. You should check this page 
        occasionally to ensure you are familiar with any changes.
      </p>

      <div className="bg-blue-50 p-6 rounded-lg">
        <p className="font-semibold mb-2">Last updated: May 14, 2025</p>
        <p>
          If you have any questions about this disclaimer, please contact us at legal@explanatum.co.uk.
        </p>
      </div>
    </div>
  );
};

export default DisclaimerPage;
